(function () {
  "use strict";

  angular
    .module("admin.comments.service", [])
    .factory("CommentsAdminService", CommentsAdminService);

  /** @ngInject */
  function CommentsAdminService($http, $q, API) {
    function list(parentId, start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/admin_posts/" +
            parentId +
            "/comments?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function save(parentId, model) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL + "admin/admin_posts/" + parentId + "/comments",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(parentId, id, model) {
      var defered = $q.defer();

      $http
        .put(
          API.API_URL + "admin/admin_posts/" + parentId + "/comments/" + id,
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(parentId, id) {
      var defered = $q.defer();

      $http
        .delete(
          API.API_URL + "admin/admin_posts/" + parentId + "/comments/" + id
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function report(id) {
      var defer = $q.defer();

      $http
        .post(API.API_URL + "admin/comments/" + id + "/report")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    function hide(id) {
      var defer = $q.defer();

      $http
        .post(API.API_URL + "admin/comments/" + id + "/hide")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    function clearReport(id) {
      var defer = $q.defer();

      $http
        .delete(API.API_URL + "admin/comments/" + id + "/reports")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    function unhidden(id) {
      var defer = $q.defer();

      $http
        .delete(API.API_URL + "admin/users/" + id + "/block")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    function block(postId, userId) {
      var defer = $q.defer();

      $http
        .post(
          API.API_URL + "admin/community_posts/" + postId + "/ban/" + userId
        )
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    function unblock(postId, userId) {
      var defer = $q.defer();

      $http
        .post(
          API.API_URL + "admin/community_posts/" + postId + "/unban/" + userId
        )
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    return {
      list: list,
      save: save,
      update: update,
      remove: remove,
      report: report,
      hide: hide,
      clearReport: clearReport,
      unhidden: unhidden,
      block: block,
      unblock: unblock,
    };
  }
})();
